import { useQueryClient } from "@tanstack/react-query";
import { CalendarX2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import Throbber from "@/components/throbber";
import { useCancelCardSubscription } from "@/hooks/use-mutations";

const CancelSubscription = ({
  cardData,
  closeModal,
}: {
  cardData: Card;
  closeModal: () => void;
}) => {
  const queryClient = useQueryClient();

  const { mutate: cancelSubscription, isPending } = useCancelCardSubscription({
    id: cardData.id,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["cardInfo", cardData.id] });
      queryClient.invalidateQueries({
        queryKey: ["cardSubscription", cardData.id],
      });
      queryClient.invalidateQueries({ queryKey: ["cards"] });
      closeModal();
    },
  });

  return (
    <div className="mx-auto flex flex-col items-center text-center">
      <div className="border-primary-100 bg-dark-error-300 flex size-16 items-center justify-center rounded-full border">
        <CalendarX2 className="size-6 text-white" strokeWidth={1.5} />
      </div>
      <p className="text-white mt-4 text-2xl font-medium">
        Cancel Subscription
      </p>
      <p className="text-white text-sm">
        Are you sure you want to cancel this card&apos;s subscription? It will be
        deactivated immediately, and you can reactivate it later.
      </p>

      <div className="mt-6 flex w-full gap-2">
        <Button
          variant={"outline"}
          onClick={() => closeModal()}
          className="border-dark-background-secondary text-white grow rounded-md border bg-transparent"
        >
          Keep subscription
        </Button>
        <Button
          onClick={() => cancelSubscription()}
          disabled={isPending}
          className="bg-dark-error-300 hover:bg-dark-error-300/90 grow rounded-md"
        >
          {isPending ? <Throbber /> : "Cancel subscription"}
        </Button>
      </div>
    </div>
  );
};

export default CancelSubscription;
